import React,{useState,useRef,useEffect} from "react";
import { motion, AnimatePresence, rgbUnit } from "framer-motion";

export default function SliderLeft() {
    const [texts,setTexts]=useState(["Best Quality","Best Price","Best Care"]);
    const [isActive, setIsActive] = useState(true);
    const [textIndex, setTextIndex] = useState(0);

    useEffect(() => {
        let timer;
        if (texts.length > 1) {
          timer = setInterval(() => {
            setTextIndex((prev) => (prev + 1) % texts.length);
          }, 5400);
        } else {
          setTextIndex(0);
        }
        return () => clearInterval(timer);
    }, [texts,isActive]);


    return (
        <div className="wptb-left-pane">
            <div className="logo">
                {/* <h6>Offers</h6> */}
            
            <AnimatePresence initial={true} >
                <motion.div
                    initial={{ x: "-100%", opacity: 0 }}
                    animate={isActive?{ x: ["-100%", "0%", "0%","0%","0%","0%","-80%","-100%"], opacity: [0,1,1,1,1,1,1,0] }:""}
                    exit={{ x: "100%", opacity: 0 }}
                    transition={{duration: 5.4, repeat: Infinity }}
                >
                    <h2 class="wptb-item--title text-outline" style={{webkitTextStrokeWidth: '0.7px', webkitTextStrokeColor: '#2A4759',letterSpacing: '8px',fontFamily:"system-ui"}}>{texts[textIndex]}</h2>
                    
                </motion.div>
                
            </AnimatePresence>
            </div>
        </div>
    );
}
